export default __webpack_public_path__ + "static/media/x-mark.2722f011.svg";